<template>
    <div class="c-loader__container" :class="{'c-loader__container--loading' : loading}">
        <template v-if="loading">
            <c-loader></c-loader>
        </template>
        <slot v-else></slot>
    </div>
</template>

<script>
import CLoader from '@components/loader/Animation';

export default {
    components: { CLoader },
    props: {
        loading: {
            type: Boolean,
            default: true
        }
    }
}
</script>
